module.exports = __webpack_public_path__ + "img/Fb-reservation-cn.e2f229c9.png";